import {
  FETCH_DOCUMENTS_IS_COMPLETE,
  FETCH_DOCUMENTS_IS_ERROR,
  FETCH_DOCUMENTS_IS_PENDING,
  FETCH_DOWNLOAD_IS_COMPLETE,
  FETCH_DOWNLOAD_IS_ERROR,
  FETCH_DOWNLOAD_IS_PENDING,
  SORT,
} from 'services/Account/Documents/types';
import { SortDirection } from 'types/common/sorting';
import { sort } from 'utils/functions';

const INITIAL_STATE = {
  docs: [],
  sortBy: 'uploadedAt',
  sortDirection: 'ASC' as SortDirection,
  params: {
    type: 'function',
    sortSearchParam: 'createdAt',
    sortSearchValue: (item: $TSFixMe) => item.createdAt,
  },
  docIsCompleted: false,
  docIsPending: false,
  docIsError: null,
  downloadIsCompleted: false,
  downloadIsPending: false,
  downloadIsError: null,
};

const docsReducer = (
  state = {
    ...INITIAL_STATE,
  },
  action = undefined,
) => {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  switch (action.type) {
    case FETCH_DOCUMENTS_IS_COMPLETE: {
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        docs: sort(action.data, {
          sortBy: state.sortBy,
          sortDirection: state.sortDirection,
          sortSearchValue: state.params.sortSearchValue || (state.params as $TSFixMe).value || null,
        }),
        docIsCompleted: true,
        docIsPending: false,
        docIsError: null,
      };
    }

    case SORT:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        sortBy: action.params.sortSearchParam,
        sortDirection: state.sortDirection === 'ASC' ? 'DESC' : 'ASC',

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        params: action.params,
        docs: sort(state.docs, {
          // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
          sortBy: action.params.sortSearchParam,
          sortDirection: state.sortDirection === 'ASC' ? 'DESC' : 'ASC',

          // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
          sortSearchValue: action.params.sortSearchValue || action.params.value,
        }),
      };

    case FETCH_DOCUMENTS_IS_PENDING: {
      return {
        ...state,
        docIsCompleted: false,
        docIsPending: true,
        docIsError: null,
      };
    }

    case FETCH_DOCUMENTS_IS_ERROR: {
      return {
        ...state,
        docIsCompleted: true,
        docIsPending: false,
        docIsError: true,
      };
    }

    case FETCH_DOWNLOAD_IS_COMPLETE: {
      return {
        ...state,
        downloadIsCompleted: true,
        downloadIsPending: false,
        downloadIsError: null,
      };
    }

    case FETCH_DOWNLOAD_IS_PENDING: {
      return {
        ...state,
        downloadIsCompleted: false,
        downloadIsPending: true,
        downloadIsError: null,
      };
    }

    case FETCH_DOWNLOAD_IS_ERROR: {
      return {
        ...state,
        downloadIsCompleted: true,
        downloadIsPending: false,
        downloadIsError: true,
      };
    }

    default:
      return state;
  }
};

export default docsReducer;
